import { render, staticRenderFns } from "./taskSkillParams.vue?vue&type=template&id=12a6c587&scoped=true&"
import script from "./taskSkillParams.vue?vue&type=script&lang=js&"
export * from "./taskSkillParams.vue?vue&type=script&lang=js&"
import style0 from "./taskSkillParams.vue?vue&type=style&index=0&id=12a6c587&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a6c587",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12a6c587')) {
      api.createRecord('12a6c587', component.options)
    } else {
      api.reload('12a6c587', component.options)
    }
    module.hot.accept("./taskSkillParams.vue?vue&type=template&id=12a6c587&scoped=true&", function () {
      api.rerender('12a6c587', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/task/taskSkillParams.vue"
export default component.exports